module.exports = __webpack_public_path__ + "historical_portfolio_horizontal.e6f9a85f8aa3198bfd753e936f4a23fd.png";